import React, { useEffect, useState } from "react";

import Box from "@mui/material/Box";
import { IoChevronUpCircle  } from "react-icons/io5";
import { FaAngleUp } from "react-icons/fa6";

// Styled comp:
import { styled } from '@mui/material/styles';

// Theme
import { useTheme } from '@mui/material/styles';

// context
import { IconContext } from "react-icons";

    const ScrollUpBtn =  styled(Box) ({

        position:'fixed',
        bottom: '1rem',
        right:'0.75rem',
        zIndex:10,
        padding:'0.3rem',
        borderRadius:'0.3rem'
    });


function ScrollUpButton(){

    const [showScrollBtn,setShowScrollBtn] = useState(false);

    const theme = useTheme();

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    },[])

    const handleScroll = () => {

        setShowScrollBtn(window.scrollY > 0 );

    }

    const onScrollToTop = (oEvent) => {
        window.scrollTo({top: 0,left:0, behavior: 'smooth'});
    }

    return(
        <ScrollUpBtn onClick={onScrollToTop} display={ showScrollBtn ? 'block' : 'none'}>
            <IconContext.Provider value={{ size:'3rem', color: theme.palette.primary.main
            }}>
                <IoChevronUpCircle/>
            </IconContext.Provider>
            
        </ScrollUpBtn>
    )
}
export default ScrollUpButton;